// extracted by mini-css-extract-plugin
export default {"root":"obFPrgyT","root__type_sending":"CKth6yyy","root__type_sent":"fXjBwroM","root__type_read":"FXUVM2qm","root__type_error":"EIL9LwFO"};